<template>
    <v-dialog
            v-model="isOpen"
            max-width="1200"
        >
            <v-card>
                <v-card-text>
                    <v-app>
                        <v-content>
                            <UpdateTemplate></UpdateTemplate>
                        </v-content>
                    </v-app>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <b-button type="is-default" @click="close()">Закрыть</b-button>
                    <b-button type="is-primary" @click="send()"
                        >Сохранить</b-button
                    >
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<script>
import UpdateTemplate from "@/app/admin/notification_templates/views/updateTemplate.vue";

export default {
    name: "CreateTemplate",
    components: {
        UpdateTemplate,
    },
    computed: {
        isOpen: {
            get() {
                return this.$store.getters.IS_CREATE_MESSAGE_TEMPLATE_MODAL_IS_OPENED;
            },
            set() {
                this.$store.dispatch('CREATE_TEMPLATE_MODAL', false);
            }
        },
    },
  methods: {
      close() {
          this.$store.dispatch('CREATE_TEMPLATE_MODAL', false);
      },
      send() {
          this.close();
      },
  },
};
</script>

<style></style>
